exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".th-low-priority-row[data-v-7f7dd475] {\n  color: #55CE63;\n  border-bottom: 2px solid #55CE63;\n}\n.th-medium-priority-row[data-v-7f7dd475] {\n  color: #409EFF;\n  border-bottom: 2px solid #409EFF;\n}\n.th-high-priority-row[data-v-7f7dd475] {\n  color: #F62D51;\n  border-bottom: 2px solid #F62D51;\n}\n.ticket-link[data-v-7f7dd475] {\n  text-decoration: none;\n  color: inherit;\n}\n.ticket-risks-table tr[data-v-7f7dd475] {\n  white-space: normal;\n}\n.ticket-risks-table tr td[data-v-7f7dd475] {\n  white-space: inherit;\n}\n", ""]);

// exports
